<template>
    <div>
        <label v-if="label" :for="id">{{ label }}:</label>
        <div
            class="relative flex justify-between border-2 border-gray-500 text-30"
            :class="{ 'border-red-500': errors.length }"
        >
            <div
                v-if="leftText"
                class="flex items-center justify-center text-gray-500 border-r-2 border-gray-500 text-30 px-30 "
                :class="{ 'border-red-500': errors.length }"
            >
                {{ leftText }}
            </div>
            <input
                v-if="type == 'text'"
                :id="id"
                ref="input"
                v-bind="$attrs"
                class="flex-1 p-30"
                :class="[classInput]"
                :type="type"
                :value="value"
                @input="$emit('input', $event.target.value)"
            />
            <the-mask
                v-if="type == 'phone'"
                :id="id"
                ref="input"
                v-bind="$attrs"
                class="flex-1 p-30 "
                :class="[classInput]"
                type="text"
                :value="value"
                @input="$emit('input', $event)"
                mask="(KKK) #### ####"
                :tokens="mask.tokens"
            ></the-mask>
            <CurrencyInput
                :value="value"
                v-if="type == 'money'"
                :id="id"
                ref="input"
                v-bind="$attrs"
                :options="mask.money"
                class="flex-1 p-30 md:w-8/12 md:flex-none"
                :class="[classInput]"
                @input="$emit('input', $event)"
            ></CurrencyInput>

            <div
                v-if="rightText"
                class="flex items-center justify-center text-gray-500 border-l-2 border-gray-500 text-30 md:text-25 px-30 md:px-15 md:w-4/12 md:flex-none"
                :class="{ 'border-red-500': errors.length }"
            >
                {{ rightText }}
            </div>
        </div>

        <div v-if="errors.length" class="mt-10 text-red-500 text-25">
            {{ errors[0] }}
        </div>
    </div>
</template>

<script>
import { get } from "http";
import { TheMask } from "vue-the-mask";
import CurrencyInput from "./CurrencyInput";

export default {
    inheritAttrs: false,
    components: {
        TheMask,
        CurrencyInput
    },
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${this._uid}`;
            }
        },
        type: {
            type: String,
            default: "text"
        },
        value: [String, Number],
        label: String,
        leftText: String,
        rightText: String,
        classInput: String,
        errors: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            mask: {
                tokens: {
                    K: {
                        pattern: /[1-9]/
                    },
                    "#": {
                        pattern: /\d/
                    }
                },
                money: {
                    currency: "IDR",
                    currencyDisplay: "narrowSymbol",
                    valueRange: {
                        // min: 0
                    },
                    hideCurrencySymbolOnFocus: false,
                    hideGroupingSeparatorOnFocus: false,
                    hideNegligibleDecimalDigitsOnFocus: false,
                    autoDecimalDigits: false,
                    autoSign: true,
                    useGrouping: true,
                    accountingSign: false
                }
            }
        };
    },
    methods: {
        focus() {
            this.$refs.input.focus();
        },
        select() {
            this.$refs.input.select();
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end);
        }
    },
    mounted() {
        console.log("type", this.type);
    }
};
</script>
